/**
 * list-search-schema — Shared Zod base schema for URL-synced list state.
 *
 * Defines the common fields used across all list pages:
 * search, page, perPage, sortBy, sortDir.
 *
 * Each route extends this schema with domain-specific filters via .extend().
 */

import { z } from 'zod'

export const listSearchSchema = z.object({
  search: z.string().optional(),
  page: z.coerce.number().int().min(1).optional(),
  perPage: z.coerce.number().int().min(1).max(100).optional(),
  sortBy: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
})

export type ListSearchParams = z.infer<typeof listSearchSchema>
